<template>
  <div>
    <router-link to="/act5/main">
      <div class="main" style="background-image:url(static/img/act/5/banner/bg.jpg)" >
        <img class="act-5-banner-cattle-left act-5-3d" src="static/img/act/5/banner/cattle-left.png">
        <img
          class="act-5-banner-cattle-right act-5-3d-right"
          src="static/img/act/5/banner/cattle-right.png"
        >
        <img class="act-5-banner-btn" src="static/img/act/5/banner/btn-show.png">
      </div>
    </router-link> 
  </div>
</template>
 

<script>
import NavTabbar from '@/components/NavTabbar.vue' 
import { ImagePreview } from "vant";
//动画
import Velocity from "velocity-animate";

export default {
  name: "Act5Index",
  components: {
    'nav-tabbar': NavTabbar,   
    "van-image-preview": ImagePreview
  },
  data() {
    return {
      preview: "",
    };
  },
  mounted() {},
  created() {    
    this.setDocumentV2(
      "三江狂野斗牛",
      "",
      "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/static/img/act/5/share.jpg?v=2"
    );
    _czc.push(['_trackEvent', '三江狂野斗牛', '点击', 'Banner页面','0','5']);  
  },
  methods: {
    displayPhoto(id) {
      this.preview = ImagePreview({
        images: ["static/img/act/5/photo/" + id + ".jpg"],
        showIndex: false
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {  
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden;
}

.act-5-banner-btn {
  position: absolute;
  width: 10%;
  right: 4%;
  top: 58%;
}
.act-5-banner-cattle-left {
  position: absolute;
  bottom: 1.5rem;
  /*left: -43.4%;*/
  left: -110%;
  width: 98%;
  max-width: 100%;
}
.act-5-banner-cattle-right {
  position: absolute;
  bottom: 1.5rem;
  /*right: -52.4%;*/
  right: -110%;
  width: 110%;
  max-width: 110%;
}

@-webkit-keyframes act-5-animation {
  /*0% {
    -webkit-transform: translateX(-110%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-110%);
    -moz-transform-origin: top center;
    transform: translateX(-110%);
    transform-origin: top center;
  }
  1% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  } */
  0% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  40% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
}

@keyframes act-5-animation {
  0% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  40% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(64.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(64.4%);
    -moz-transform-origin: top center;
    transform: translateX(64.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(70.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(70.4%);
    -moz-transform-origin: top center;
    transform: translateX(70.4%);
    transform-origin: top center;
  }
}

.act-5-3d {
  -webkit-animation: act-5-animation 10000ms ease-in-out alternate infinite;
  -moz-animation: act-5-animation 10000ms ease-in-out alternate infinite;
  animation: act-5-animation 10000ms ease-in-out alternate infinite;
  animation-delay: 560ms;
  -webkit-animation-delay: 560ms;
}

@-webkit-keyframes act-5-animation-right {
  0% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  40% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
}

@keyframes act-5-animation-right {
  0% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  20% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  40% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  60% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
  80% {
    -webkit-transform: translateX(-56.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-56.4%);
    -moz-transform-origin: top center;
    transform: translateX(-56.4%);
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateX(-50.4%);
    -webkit-transform-origin: top center;
    -moz-transform: translateX(-50.4%);
    -moz-transform-origin: top center;
    transform: translateX(-50.4%);
    transform-origin: top center;
  }
}

.act-5-3d-right {
  -webkit-animation: act-5-animation-right 10000ms ease-in-out alternate
    infinite;
  -moz-animation: act-5-animation-right 10000ms ease-in-out alternate infinite;
  animation: act-5-animation-right 10000ms ease-in-out alternate infinite;
  animation-delay: 560ms;
  -webkit-animation-delay: 560ms;
}
</style>


// WEBPACK FOOTER //
// src/components/act/5/Banner.vue